import React, { useState, useRef } from 'react';
import { styled, Textarea } from '@teko/ds-desktop';
import { CartItem } from '@teko/cart/v2';
import { useCartV2 } from '../CartContextV2';
import { t } from 'i18n';
import { getDisabledUserActions } from '../utils';

const StyledTextArea = styled(Textarea)`
  width: 100%;
  margin-top: 0.5rem;
  > :first-child {
    resize: none;
  }
`;

interface ProductNoteInputProps {
  item: CartItem;
}

export const ProductNoteInput: React.FC<ProductNoteInputProps> = ({ item }) => {
  const { onUpdateItemNote } = useCartV2();
  const { disableAddItemNote } = getDisabledUserActions(item);
  const [productNote, setProductNote] = useState(item.note || '');
  const previousProductNote = useRef(productNote);

  const handleBlur = () => {
    if (previousProductNote.current !== productNote) {
      onUpdateItemNote(item, productNote);
      previousProductNote.current = productNote;
    }
  };

  return (
    <StyledTextArea
      placeholder={t('Ghi chú sản phẩm')}
      value={productNote}
      rows={1}
      maxLength={1000}
      onChange={(value) => setProductNote(value)}
      onBlur={handleBlur}
      disabled={disableAddItemNote}
    />
  );
};
